/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOdyssey = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 20"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 20px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path
          strokeLinejoin="round"
          d="M23.13 7.3L12 .88.88 7.3h0L12 13.72 23.13 7.3z"
        />
        <path
          strokeLinecap="round"
          d="M.88 7.3v5.08m0 2v.72m3.58-5.72v5.44a1.09 1.09 0 0 0 .54.94l4.81 2.78a4.37 4.37 0 0 0 4.34 0L19 15.76a1.08 1.08 0 0 0 .55-.94V9.38"
        />
      </g>
    </svg>
  ),
);
